import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonFunction } from '../main/CommonFunction';
import { Subscription } from 'rxjs';
import { CustomDateFormat } from './CustomDateFormat';
import { DatePipe } from '@angular/common';
import { ButtonRendererComponent } from './masters/cellRendererCustomNotes.component';
@Component({
    selector: 'customer-division-restrict-template',
    template: require('./CommonCustomerDivisionRestrictTemplate.html'),
    styles: [``]
})
export class CommonCustomerDivisionRestrictTemplateComponent implements OnInit {
    @Input('customername') Customer_Name: any;
    @Input('name') Name: any;
    @Input('customerid') Customer_ID: any;
    @Input("dValue") dvalue: any;

    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, CommonFunction, CustomDateFormat, DatePipe]
    bsConfig: any;
    busy: Subscription;
    public overlayNoRowsTemplate: any;
    toastWarningMsg(msg) {
        this.toast({ type: 'warning', title: msg });
    }
    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public commonFunction: CommonFunction, public customDateFormat: CustomDateFormat, public datePipe: DatePipe) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.unitInfo.dateInputFormat, containerClass: this.unitInfo.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.unitInfo.dateInputFormat;
        this.frameworkComponents = {
            buttonRenderer: ButtonRendererComponent,
        }
        this.defaultColDef = {
            resizable: true,
            sortable: true
        };

        $(document).ready(function () {
            var header = $('vendor-outstanding-template .modal-header').height();
            var body = $('vendor-outstanding-template').parent().height();
            var appHeight = body - header + 'px !important';
            $('.modal-body .table-responsive.outstanding').attr('style', 'height:' + appHeight);
        })
    }

    dateFormat: any;

    gridColumnApiCustomerRestrict: any;
    gridApiCustomerRestrict: any;
    paginationConf: any;
    d: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    modalReference: NgbModalRef;
    public overlayLoadingTemplate: any;
    public hotkeyList: Hotkey[];
    Config_Leger_From_Date: any;
    Custfiltervalue: any;
    searchobject: any;
    public manufacturerList: any;
    public divisionList: any;
    frameworkComponents: any;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    ngOnInit(): void {
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.overlayNoRowsTemplate = "<h4> No record to show. </h4>";
        this.paginationConf = UserSettings.enablePagination;

        this.RestrictDivisionDef = [
            { headerName: 'Manufacturer', field: 'Manufacturer', width: 150 },
            { headerName: 'Division', field: 'Division', width: 150 },
            {
                headerName: 'Action', cellRenderer: 'buttonRenderer'
                , cellRendererParams: {
                    onClick: this.DeleteDvivision.bind(this),
                    icon: 'fas fa-trash'
                }, width: 150
                //cellStyle: { textAlign: "right" } 
            },
        ];
        this.initHotkeys();
        this.initManufacturerList();
        this.GetRestrictDivision();
        setTimeout(() => {
            $('#manufacturer input[role=combobox]').focus();
        }, 200);
        this.searchobject = {};

        this.Custfiltervalue = '';

        this.RestrictDivisionRowData = [];
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";
    }

    initHotkeys() {
        this.hotkeyList = [];
        let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            $('vendor-outstanding-template #excelbtn').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrle);
        this.hotkeysService.add(ctrle);

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
            $("#cust-RD-filter-text-box").focus();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chkNum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    RestrictDivisionRowData: any;;
    RestrictDivisionDef: any;


    customerdivisionrestrictGridReady(params) {
        this.gridApiCustomerRestrict = params.api;
        this.gridColumnApiCustomerRestrict = params.columnApi;
        this.gridApiCustomerRestrict.sizeColumnsToFit();
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    exportoutstandingven() {
        //  let vndrName = this.unitInfo.Company_Name + '\n' + this.unitInfo.Company_Full_Address + '\n' + 'Vendor Name :' + this.Vendor_Name;
        let d = new Date();
        var fName = 'Outstanding_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            //   customHeader: vndrName,
            fileName: fName,
        };
        this.gridApiCustomerRestrict.exportDataAsCsv(params);
    }

    onPopupFilterTextBoxChanged(e) {
        let value = $('input#cust-RD-filter-text-box').val();
        this.gridApiCustomerRestrict.setQuickFilter(value);
    }

    venKeyDown(event) {
        if (event.which == 13) {
            this.gridApiCustomerRestrict.setFocusedCell(0, "Manufacturer");
        }
    }

    initManufacturerList() {
        this.busy = this.http.get('/api/Manufacturers/getManufacturerslist/' + JSON.stringify({ "Unit_ID": this.unitInfo.Unit_ID }))
            .subscribe(response => {
                this.manufacturerList = response;
            })
    }

    getDivisionBasedOnManufac1(id) {
        this.searchobject.Division_ID = '';
        let data = { "Manufacturer_ID": id, "Unit_ID": this.unitInfo.Unit_ID };
        this.http.post(`/api/${this.unitInfo.Company_Code}/products/getManufacturerDivision`, data)
            .subscribe(response => {
                this.divisionList = response;
                if (this.divisionList.length == 1) {
                    this.searchobject.Division_ID = this.divisionList[0].Division_ID;
                }
                $('#Division_ID input[role=combobox]').focus();
            })
    }

    InsertRestrictDivision() {
        if (this.f_chkNum(this.searchobject.Manufacturer_ID) == 0) {
            this.toastWarningMsg("Manufacturer can not be blank");
            $('#manufacturer input[role=combobox]').focus();
            return false;
        }

        if (this.f_chkNum(this.searchobject.Division_ID) == 0) {
            this.toastWarningMsg("Division can not be blank");
            $('#Division_ID input[role=combobox]').focus();
            return false;
        }

        let data = { "Customer_ID": this.Customer_ID, "Manufacturer_ID": this.searchobject.Manufacturer_ID, "Division_ID": this.searchobject.Division_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID };
        this.http.post('/api/customers/InsertRestrictDivision', data)
            .subscribe(response => {
                if (response[0].flag == 1) {
                    this.searchobject = {};
                    this.GetRestrictDivision();
                    $('#manufacturer input[role=combobox]').focus();
                } else {
                    this.toastWarningMsg(response[0].msg);
                    $('#Division_ID input[role=combobox]').focus();
                    return false;
                }


            })
    }

    GetRestrictDivision() {
        let data = { "Customer_ID": this.Customer_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID };
        this.http.post('/api/customers/GetRestrictDivision', data)
            .subscribe(response => {

                this.RestrictDivisionRowData = response;

            })
    }

    NextMove() {
        $('#okbtn1').focus();
    }

    DeleteDvivision(e) {
        Swal({
            title: 'Delete',
            text: "Do you want to delete division ?",
            type: 'warning',
            showCancelButton: true,
            focusConfirm: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm',
            customClass: 'swal-warning-custom',

        }).then(result => {
            if (result.value) {
                this.DeleteFunction(e.rowData);
            }
            return;

        }).catch(err => console.log(err));

    }

    DeleteFunction(p_data) {
        let data = { "Customer_ID": p_data.Customer_ID, "Manufacturer_ID": p_data.Manufacturer_ID, "Division_ID": p_data.Division_ID, "Unit_ID": p_data.Unit_ID, "Company_ID": p_data.Company_ID };

        this.http.post('api/customers/DeleteRestrictDivision', data)
            .subscribe(response => {
                if (response[0].flag === 1) {
                    // this.listAll();
                    this.toastsuccessMsg("Recored deleted sucessfull");
                    this.searchobject = {};
                    this.GetRestrictDivision();
                    $('#manufacturer input[role=combobox]').focus();

                }
                if (response[0].flag === 0) {
                    this.toastWarningMsg("Recored not deleted " + response[0].msg);

                }
            })
    }

    toastsuccessMsg(msg) {
        this.toast({ type: 'success', title: msg });
    }
}

